export default (value) => {
  return String(value).toLowerCase().replace(/[^a-z]/g, '')
}
